export const gotuuPicsLight = [
  {
    imgSource: "https://i.postimg.cc/CLW7jtb8/main-page-light-1.png",
    imgText: "Main Page for play/pause",
  },
  {
    imgSource: "https://i.postimg.cc/mrSSWgJ3/work-page-light-6.png",
    imgText: "Stopwatch started and start of a tuu",
  },
  {
    imgSource: "https://i.postimg.cc/N0txnHJf/note-page-light-6.png",
    imgText: "Including task note for the current time tuu.",
  },
  {
    imgSource: "https://i.postimg.cc/0Q20kq1T/timeline-page-light-5.png",
    imgText:
      "Timeline showing each Tuu (interval), its corresponding note and whether the tasks on the note are completed or not.",
  },
  {
    imgSource: "https://i.postimg.cc/cH9M65sr/metrics-page-light-5.png",
    imgText: "Metrics and statistics page based on performance",
  },
  {
    imgSource: "https://i.postimg.cc/rs71N0RT/login-page-light-2.png",
    imgText: "Login Page for Gotuu",
  },
  {
    imgSource: "https://i.postimg.cc/XqrK5cJx/register-page-light-3.png",
    imgText: "Registration Page for Gotuu",
  },
  {
    imgSource: "https://i.postimg.cc/0Q20kq1T/timeline-page-light-5.png",
    imgText: "About section containing tutorials on how to use the features.",
  },
];

export const gotuuPicsDark = [
  {
    imgSource: "https://i.postimg.cc/NMXB0LqV/main-page-dark-1.png",
    imgText: "Main Page for play/pause",
  },
  {
    imgSource: "https://i.postimg.cc/zX88JJdt/work-page-dark-6.png",
    imgText: "Stopwatch started and start of a tuu",
  },
  {
    imgSource: "https://i.postimg.cc/mZQTfcS1/note-page-dark-6.png",
    imgText: "Including task note for the current time tuu.",
  },
  {
    imgSource: "https://i.postimg.cc/kg5CbTPW/timeline-page-dark-5.png",
    imgText:
      "Timeline showing each Tuu (interval), its corresponding note and whether the tasks on the note are completed or not.",
  },
  {
    imgSource: "https://i.postimg.cc/YqRk0JZp/metrics-page-dark-5.png",
    imgText: "Metrics and statistics page based on performance",
  },
  {
    imgSource: "https://i.postimg.cc/vmgdPDBB/login-page-dark-2.png",
    imgText: "Login Page for Gotuu",
  },
  {
    imgSource: "https://i.postimg.cc/kghmFW7z/register-page-dark-3.png",
    imgText: "Registration Page for Gotuu",
  },
  {
    imgSource: "https://i.postimg.cc/tgKG8yZz/about-page-dark-4.png",
    imgText: "About section containing tutorials on how to use the features.",
  },
];

export const aunshPicsLight = [
  {
    imgSource: "https://i.postimg.cc/GpPFH4Hf/aunsh-Portfolio-Light-Five.png",
    imgText: "Homepage of my portfolio website",
  },
  {
    imgSource: "https://i.postimg.cc/q72LymZj/aunsh-Portfolio-Light-One.png",
    imgText: "Admin dashboard pages showcasing recent messages",
  },
  {
    imgSource: "https://i.postimg.cc/ydBTPFMB/aunsh-Portfolio-Light-Two.png",
    imgText: "Metrics pages for recent hits, message metrics and more",
  },
  {
    imgSource: "https://i.postimg.cc/RFrYz62b/aunsh-Portfolio-Light-Three.png",
    imgText: "Various functionalities for messages",
    needsFit: true,
  },
];

export const aunshPicsDark = [
  {
    imgSource: "https://i.postimg.cc/c4VdBbM2/aunsh-Portfolio-Dark-Five.png",
    imgText: "Homepage of my portfolio website",
  },
  {
    imgSource: "https://i.postimg.cc/05XkbQ68/aunsh-Portfolio-Dark-One.png",
    imgText: "Admin dashboard pages showcasing recent messages",
  },
  {
    imgSource: "https://i.postimg.cc/bNGzbhb1/aunsh-Portfolio-Dark-Two.png",
    imgText: "Metrics pages for recent hits, message metrics and more",
  },
  {
    imgSource: "https://i.postimg.cc/wMrgPfKt/aunsh-Portfolio-Dark-Three.png",
    imgText: "Various functionalities for messages",
    needsFit: true,
  },
];

export const funWithRedditPics = [
  {
    imgSource: "https://i.postimg.cc/mkDwK7T9/homepage-1.png",
    imgText: "Home page of FwR",
  },
  {
    imgSource: "https://i.postimg.cc/ydkCBQX6/funwithredditworking.gif",
    imgText: "A walk-through of the features of FwR",
  },
];

export const omdbAPIPics = [
  {
    imgSource: "https://i.postimg.cc/rw9ScBMj/omdb2.png",
    imgText: "Searching a string 'harry' provides movies card",
  },
  {
    imgSource: "https://i.postimg.cc/MKCByWKd/omdb1.png",
    imgText: "Home page of Omdb API Project",
  },
  {
    imgSource: "https://i.postimg.cc/dDP0TVmC/omdb3.png",
    imgText: "Modal showing individual movie details",
  },
];
